// extracted by mini-css-extract-plugin
module.exports = {"flagContainer":"styles_flagContainer__CuBMc","flag":"styles_flag__3r7WB"};